import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { exportsGetTaskFile, exportsTaskRemove, createPdfExportTask, createXlsExportTask } from '../../actions'

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            exportsGetTaskFile,
            exportsTaskRemove,
            createPdfExportTask,
            createXlsExportTask,
        },
        dispatch
    )
}

export default (InnerComponent) => {
    @connect(null, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
